"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.reports.cost': 'Report dei Costi',
    'route.reports.shared': 'Conversazioni Condivise',
};
